const getCpuClass = (): string | undefined => {
    return navigator.cpuClass;
}

export default getCpuClass;